module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-ge-c1596dae24ee26df61161d7150588d43.png";